<template>
  <div>
    <section v-show="is_new_user !== null" class="m-content m-content-full wallet-home">
      <div class="row justify-content-center">
        <div v-if="overdraftPaid === false" class="col-12">
          <div class="m-alert m-alert--icon alert alert-congrat" role="alert">
            <div class="m-alert__images m--hidden-mobile">
              <img class="left" src="/images/alert-left.png" />
              <img class="right" src="/images/alert-right.png" />
            </div>
            <div class="m-alert__images m--hidden-desktop m--hidden-tablet">
              <img class="top" src="/images/alert-mobile.png" />
            </div>
            <div class="m-alert__text text-center">
              <p>
                <b>GOOD NEWS {{firstname.toUpperCase()}}!</b>
              </p>
              <h4>
                You have been selected for a
                <b>N100,000</b> CarbonFlex facility.
              </h4>
              <router-link
                class="btn btn-primary m-btn--wide m--margin-top-10 m--hidden-mobile"
                :to="{ name: 'overdraft' }"
              >Learn more</router-link>
              <router-link
                class="learn-more m--hidden-desktop m--hidden-tablet"
                :to="{ name: 'overdraft' }"
              >
                Tap to learn more &ensp;&ensp;
                <i class="fa fa-chevron-right"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-md-6 col-lg-6">
          <div class="widget widget--air-style widget--wallet">
            <div class="widget__header">
              <h3 class="widget__title">YOUR WALLET</h3>
              <div class="widget__tools">{{moment().format('MMM D. YYYY')}}</div>
            </div>
            <div class="widget__body">
              <h6 class="wallet_balance_title">Wallet Balance</h6>
              <div class="text-center">
                <div class="wallet_balance">
                  <svg svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="40" height="45" class="N" viewBox="0 0 24 18"><path d="M3.006 11.465v4.42H.986v1.777h7.165v-1.777H6.132v-4.42zM19.662 6.2V1.776h2.019V0h-7.165v1.776h2.019V6.2zM16.534 11.465v1.907l-1.428-1.9h-3.588l4.654 6.2h3.489v-6.2zM6.133 6.2V4.3l1.428 1.9h3.587L6.495 0H3.006v6.2zM23.188 6.586H0v1.952h23.188zM23.188 9.123H0v1.952h23.188z"/></svg>
                  {{walletBalance.toLocaleString('en', { minimumFractionDigits: 2,
                  maximumFractionDigits: 2})}}
                </div>
                <div class="wallet-icons">
                  <router-link
                    :to="{ name: 'under-construction', params: {paymentMethod: 'WALLET' }  }"
                    class="wallet-icon"
                  >
                    <img src="../../../../static/media/demo/default/img/misc/withdraw.png" alt />
                    <span>Withdraw</span>
                  </router-link>
                  <router-link :to="{ name: 'fund-wallet' }" class="wallet-icon">
                    <img src="../../../../static/media/demo/default/img/misc/fundwallet.png" alt />
                    <span>Fund Wallet</span>
                  </router-link>
                  <router-link :to="{ name: 'wallet-transactions' }" class="wallet-icon">
                    <img src="../../../../static/media/demo/default/img/misc/transactions.png" alt />
                    <span>Transactions</span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <div class="widget widget--air-style widget--loan">
            <div
              class="has-loan"
              v-if="loan && loan.loanStatus !== 'paid' && loan.loanStatus !== 'declined'"
            >
              <div
                v-if="loan && loan.loanStatus !== 'paid' && loan.loanStatus !== 'declined'"
                class="widget__header"
              >
                <h3 class="widget__title">YOUR LOAN</h3>
                <div
                  v-if="loan && loan.loanStatus !== 'paid' && loan.loanStatus !== 'declined'"
                  class="widget__tools"
                >{{loan.loanStatus.toUpperCase()}}</div>
              </div>

              <div
                v-if="loan && loan.loanStatus !== 'paid' && loan.loanStatus !== 'declined'"
                class="widget__body--no-padding"
              >
                <h6 class="next_loan_title">NEXT LOAN REPAYMENT</h6>
                <div class="next_loan_amount view_details" v-if="schedule !== undefined && schedule !== null">
                  <svg svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="40" height="45" class="N" viewBox="0 0 24 18"><path d="M3.006 11.465v4.42H.986v1.777h7.165v-1.777H6.132v-4.42zM19.662 6.2V1.776h2.019V0h-7.165v1.776h2.019V6.2zM16.534 11.465v1.907l-1.428-1.9h-3.588l4.654 6.2h3.489v-6.2zM6.133 6.2V4.3l1.428 1.9h3.587L6.495 0H3.006v6.2zM23.188 6.586H0v1.952h23.188zM23.188 9.123H0v1.952h23.188z"/></svg>
                  {{schedule.amountDue.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}}
                </div>
                <div class="loan_footer d-flex justify-content-between">
                  <div
                    class="loan_date"
                    v-if="schedule !== undefined && schedule !== null"
                  >{{schedule.dueDate.substring(0,10)}}</div>
                  <div class="loan_view_details">
                    <a
                      target="_blank"
                      class="view_details"
                      :href="loanRepaymentLink"
                    >View details</a>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="widget__body">
              <div class="m--padding-top-50 m--padding-bottom-50">
                <h6 class="wallet_balance_title text-center m--margin-bottom-20">
                  Need cash
                  instantly?
                </h6>
                <div class="text-center">
                  <a
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=com.lenddo.mobile.paylater&referrer=utm_source=paylaterwebsite&utm_medium=paylaternavbutton&utm_term=paylaterwebsite&utm_content=paylaternavbutton&utm_campaign%paylaterwebsite&anid=admob"
                    class="btn m-btn--wallet btn-primary  m-btn--wide"
                  >
                    Apply
                    for a
                    loan
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="widget m--hidden-mobile">
            <div class="widget__body--no-padding">
              <div class="d-flex justify-content-start">
                <div class="widget_categories_title">
                  <h3>
                    <b>MAKE PAYMENTS</b>
                    <a
                      href
                      @click.prevent
                      flow="down"
                      tooltip="Use your Carbon wallet or debit card to perform any of these popular transactions!"
                    >
                      <img src="../../../../static/media/demo/default/img/misc/info.png" alt />
                    </a>
                  </h3>
                </div>
                <div class="widget_categories_buttons">
                  <div class="widget__tools text-left">
                    <i class="fa fa-angle-left" @click="sliderBack(5)"></i>
                  </div>
                </div>
                <div class="widget_categories widget_categories--one-line">
                  <carousel
                    :perPage="5"
                    :paginationEnabled="false"
                    :navigateTo="mobileSliderCurrentPage"
                  >
                    <!--<slide v-for="category in categories" v-bind:key="`category-m-${category.id}`"  ><router-link class="widget_category_item"   :to="{ name: 'bills-payment-cateogry', params: { id: category.id , title:  category.fullName } }"></router-link>-->
                    <slide v-for="category in categories" v-bind:key="`category-m-${category.id}`">
                      <router-link class="widget_category_item" :to="{ name: 'under-construction' }">
                        <div class="widget_category_item_imageWrapper">
                          <img :src="`/images/${category.slug}.png`" :alt="category.slug" />
                        </div>
                        <span>{{category.fullName}}</span>
                      </router-link>
                    </slide>
                  </carousel>
                </div>
                <div class="widget_categories_buttons">
                  <div class="widget__tools text-right">
                    <i class="fa fa-angle-right" @click="sliderNext(5)"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="widget m--hidden-desktop m--hidden-tablet">
            <div class="widget__header">
              <h4 class="widget__title">Categories</h4>
              <div class="widget__tools">
                <i class="fa fa-angle-left" @click="sliderBack(3)"></i>
                <i class="fa fa-angle-right" @click="sliderNext(3)"></i>
              </div>
            </div>
            <div class="widget__body--no-padding">
              <div class="widget_categories">
                <carousel
                  :perPage="3"
                  :paginationEnabled="false"
                  :navigateTo="mobileSliderCurrentPage"
                >
                  <!--<slide v-for="category in categories" v-bind:key="`category-m-${category.id}`"  ><router-link class="widget_category_item"   :to="{ name: 'bills-payment-cateogry', params: { id: category.id } }"></router-link>-->
                  <slide v-for="category in categories" v-bind:key="`category-m-${category.id}`">
                    <router-link class="widget_category_item" :to="{ name: 'under-construction'}">
                      <div class="widget_category_item_imageWrapper">
                        <img :src="`/images/${category.slug}.png`" :alt="category.slug" />
                      </div>
                      <span>{{category.fullName}}</span>
                    </router-link>
                  </slide>
                </carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="widget">
            <div class="widget__header">
              <h4 class="widget__title">
                <b>MY PAYMENTS</b>
              </h4>
              <div class="widget__tools">
                <a href @click.prevent="togglePayments()">
                  <b>{{paymentToggler?'VIEW ALL':'VIEW LESS'}}</b>
                </a>
              </div>
            </div>
            <div class="widget__body--no-padding">
              <div v-if="myPayments.length > 0" class="payments__list">
                <div class="row">
                  <div
                    v-for="(payment,index) in myPayments"
                    v-bind:key="`paymentlist1-${index}`"
                    @click="onClickPayment(payment)"
                    class="make-payment-items col-lg-2 col-md-4 col-4 p-0"
                  >
                    <img
                      v-if="payment.airtimeTopup && payment.airtimeTopup.mobileNetworkOperator"
                      class="my-payment-abc d-flex align-items-center justify-content-center"
                      :src="payment.airtimeTopup.mobileNetworkOperator.logoUrl"
                    />
                    <div
                      v-else
                      class="text-center my-payment-abc d-flex align-items-center justify-content-center"
                    >{{payment.payableType.substring(0,1).toUpperCase()}}</div>
                    <span
                      class="text-center make-payment-text"
                    >{{payment.payableType.replace('_',' ')}}</span>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="not-found text-center m--padding-top-30 m--padding-bottom-40"
              >No Payment History</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
import N from "../../../components/N";

import { getWallet } from "./../../../api/wallet/walletService";
import { getStatus, getPayments } from "./../../../api/wallet/loanService";
import { getRecent } from "./../../../api/wallet/paymentService";
import vue from "vue";

import { getCategories } from "./../../../api/billsPayments/billsPaymentsService";
import routes from './../../../api/routes';
import FirebaseRepository from '../../../providers/firebase/firebase.repository';

export default {
  data: () => ({
    firstname: null,
    is_new_user: null,
    overdraftPaid: null,
    paymentToggler: true,
    loan: null,
    schedule: null,
    categories: [],
    categoriesCount: 0,
    search: "",
    clientId: null,
    myPayments: [],
    walletBalance: 0,
    mobileSliderCurrentPage: 0
  }),
  components: {
    Carousel,
    Slide,
    N
  },
  beforeCreate() {},
  mounted() {
    if (this.$store.state.Auth.user_data) {
      this.firstname = this.$store.state.Auth.user_data.firstname;
    } else {
      this.$store.dispatch("redirect", "logout");
    }
    this.checkNewUser();
    this.checkOverDraft();
    this.fetchPage();
  },
  computed: {
    loanId () {
      const { id, loanStatus } = this.$store.state.Auth.loanDetails
      if(id && ["disbursed", "overdue"].includes(loanStatus)) {
        return id
      }
      return false
    },
    userId () {
      return this.$store.state.Auth.user_data.id
    },
    loanRepaymentLink() {
      return this.loanId ? `${routes.loan.loanRedirect}?token=${this.userId}_${this.loanId}` : '/'
    },
  },
  methods: {
    onClickPayment(item) {
      if (item.payableType === "airtime_topup") {
        this.$router.push({ name: "payment-detail", params: { item: item } });
      } else if (item.payableType === "transfer") {
        this.$router.push({ name: "payment-detail", params: { item: item } });
      } else if (item.payableType === "wallet_topup") {
        this.$router.push({ name: "payment-detail", params: { item: item } });
      } else {
        this.$router.push({ name: "payment-detail", params: { item: item } });
      }
    },
    checkNewUser() {
      if (
        this.$store.state.Auth.is_new_user == "true" ||
        this.$store.state.Auth.is_new_user === true
      ) {
        this.is_new_user = true;
        this.$store.dispatch("redirect", "dashboard");
      } else {
        this.is_new_user = false;
      }
    },
    checkOverDraft() {
      let url = new URL(window.location);
      let params_ref = url.searchParams.get("ref");
      this.$store.dispatch("loader", true);
      const clientId = this.$store.state.Auth.user_data.clientId;
      FirebaseRepository.checkOverdraft(clientId)
        .then(response => {
          this.overdraftPaid = response;
          if (this.overdraftPaid === false && params_ref === "from-login") {
            this.$store.dispatch("redirect", "overdraft");
          }
        })
        .catch(e => {
          this.overdraftPaid === undefined;
        });
    },
    togglePayments() {
      if (this.paymentToggler) {
        this.fetchRecentPayments(window.innerWidth > 768 ? 24 : 12);
      } else {
        this.fetchRecentPayments(window.innerWidth > 768 ? 12 : 6);
      }
      this.paymentToggler = !this.paymentToggler;
    },
    sliderBack(itemInPage) {
      let maxPage = Math.ceil(this.categoriesCount / itemInPage);
      this.mobileSliderCurrentPage--;
      this.mobileSliderCurrentPage < 0
        ? (this.mobileSliderCurrentPage = maxPage)
        : this.mobileSliderCurrentPage;
    },
    sliderNext(itemInPage) {
      let maxPage = Math.ceil(this.categoriesCount / itemInPage);
      this.mobileSliderCurrentPage++;
      this.mobileSliderCurrentPage > maxPage
        ? (this.mobileSliderCurrentPage = 0)
        : this.mobileSliderCurrentPage;
    },
    handleClick(newTab) {
      this.currentTab = newTab;
    },
    fetchPage() {
      this.$store.dispatch("loader", true);
      getWallet()
        .then(response => {
          if (response.response.data !== undefined) {
            this.walletBalance =
              response.response.data.availableBalance > 0
                ? parseFloat(response.response.data.availableBalance) / 100
                : 0;
            this.$store.dispatch("updateInfo", {
              user_data: {
                walletId: response.response.data.accountId
              }
            });
          }
        })
        .catch(error => {
          this.$store.dispatch("handleError", {
            response: error,
            callback: this.fetchPage,
            can_cancel: true
          });
        })
        .finally(() => {
          this.$store.dispatch("loader", false);
        });
      this.fetchRecentPayments(window.innerWidth > 768 ? 12 : 6);
      this.fetchCategories();
      getStatus()
        .then(response => {
          const { response : { data }} = response
          const { state: { Auth: { loanDetails } } } = this.$store

          if (data !== undefined) {
            this.loan = data;
            if(loanDetails === {} || loanDetails.id !== data.id) {
              this.$store.commit('UPDATE_LOAN_DETAILS', data)
            }
          }
        })
        .catch(error => {
          // vue.swal.close()
          // this.$store.dispatch('handleError', {response: error, callback: this.fetchPage, can_cancel: true})
        });
      getPayments()
        .then(response => {
          if (response.response.data !== undefined) {
            let _schedule = response.response.data.filter(item => {
              return (
                item.state === "PENDING" || item.state === "PARTIALLY_PAID"
              );
            });
            this.schedule = _schedule[0];
          }
        })
        .catch(error => {
          // vue.swal.close()
          // this.$store.dispatch('handleError', {response: error, callback: this.fetchPage, can_cancel: true})
        });
    },
    fetchCategories() {
      this.$store.dispatch("loader", true);
      getCategories()
        .then(response => {
          if (response.response.data !== undefined) {
            this.categories = response.response.data.content;
            this.categoriesCount = response.response.data.totalElements;
          }
        })
        .catch(error => {
          this.$store.dispatch("handleError", {
            response: error,
            callback: this.fetchCategories,
            can_cancel: true
          });
        })
        .finally(() => {
          this.$store.dispatch("loader", false);
        });
    },
    fetchRecentPayments(limit = null) {
      this.$store.dispatch("loader", true);
      this.clientId = this.$store.state.Auth.user_data.clientId;
      getRecent(this.clientId, limit)
        .then(response => {
          if (response.response.data !== undefined) {
            this.myPayments = response.response.data;
          }
        })
        .catch(error => {
          vue.swal.close();
          this.$store.dispatch("handleError", {
            response: error,
            callback: this.fetchRecentPayments,
            can_cancel: true
          });
        })
        .finally(() => {
          this.$store.dispatch("loader", false);
        });
    }
  }
};
</script>
<style>
.view_details{
  color: #9B7DD4 !important;
}
.widget--loan .next_loan_amount svg.N path{
    fill: #9B7DD4 !important;
}
</style>
